import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs, { Dayjs } from "dayjs";

interface bookingPaymentFilterState {
  startDate: string;
  endDate: string;
  categoryId: string;
}

const initialState: bookingPaymentFilterState = {
  startDate: "",
  endDate: "",
  categoryId: "",
};

// Load from localStorage if exists
const savedFilters = localStorage.getItem("bookingPaymentFilters");
const persistedState = savedFilters
  ? {
      ...initialState,
      ...JSON.parse(savedFilters),
      // Convert ISO strings back to Dayjs
      startRange: JSON.parse(savedFilters)?.startRange
        ? dayjs(JSON.parse(savedFilters)?.startRange)
        : null,
      endRange: JSON.parse(savedFilters)?.endRange
        ? dayjs(JSON.parse(savedFilters)?.endRange)
        : null,
    }
  : initialState;

const bookingPaymentFilterSlice = createSlice({
  name: "bookingPaymentFilter",
  initialState: persistedState,
  reducers: {
    setBookingPaymentFilter(
      state,
      action: PayloadAction<Partial<bookingPaymentFilterState>>
    ) {
      Object.assign(state, action.payload);
      localStorage.setItem("bookingPaymentFilter", JSON.stringify(state));
    },
    resetBookingPaymentFilter() {
      localStorage.removeItem("bookingPaymentFilter");
      return initialState;
    },
  },
});

export const { setBookingPaymentFilter, resetBookingPaymentFilter } =
  bookingPaymentFilterSlice.actions;

export default bookingPaymentFilterSlice.reducer;
